<template>
  <el-row>
    <el-col :sm="24" :md="{span: 8, offset: 8}" style="padding:40px 0px">
      <center v-if="data && data.surveyName && data.surveyName.logo" >
        <img :src="data.surveyName.logo" width="150px" />
        <div>
          <h1>{{data.surveyName.name}} </h1>
        </div>
      </center>
    </el-col>
    <el-col :sm="24" :md="{span: 8, offset: 8}">
      <el-card class="box-card" v-if="$route.params.surveyId && data.surveyName">
        <div slot="header" class="clearfix">
          <span style="float: left;">
            {{$t(`done`)}} {{ratePercentQuestionAns(countGenerateLead + countSurveyItem,countQuestion)}}% ({{countGenerateLead + countSurveyItem}}/{{countQuestion}})
          </span>
          <el-button type="primary" size="medium" style="float: right;" @click="submitInfo" :loading="loading">{{$t(`sent`)}}</el-button>
        </div>
        <div v-if="!$route.params.leadId && data.surveyName.leadFields && data.surveyName.leadFields.length">
          <div style="margin-bottom:10px;">
            <label style="font-size: 16px;font-weight: bold;">{{$t(`personInfo`)}}</label>
          </div>
          <el-row style="margin-bottom:10px" v-if="checkRequire('fullName') || checkLeadField('fullName')">
            <el-col :span="24">
              <label for="">{{$t(`fullName`)}} {{checkRequire('fullName','*')}}</label>
            </el-col>
            <el-col :span="24">
              <el-input :class="errors.has('fullName') ? 'is-error':''" name="fullName" style="margin-top:5px" v-validate="checkRequire('fullName','required')" type="text" placeholder="Họ tên" v-model="leadInfo.fullName" />
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px" v-if="checkRequire('phone') || checkLeadField('phone')">
            <el-col :span="24">
              <label>{{$t(`phone`)}} {{checkRequire('phone','*')}}</label>
            </el-col>
            <el-col :span="24">
              <el-input :class="errors.has('phone') ? 'is-error':''" name="phone" style="margin-top:5px" v-validate="checkRequire('phone','required')" type="text" placeholder="Phone" v-model="leadInfo.phone" />
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px" v-if="checkRequire('email') || checkLeadField('email')">
            <el-col :span="24">
              <label for="">Email {{checkRequire('email','*')}}</label>
            </el-col>
            <el-col :span="24">
              <el-input :class="errors.has('email') ? 'is-error':''" name="email" style="margin-top:5px" v-validate="`${checkRequire('email','required')}|email`" type="text" placeholder="Email" v-model="leadInfo.email" />
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px" v-if="checkRequire('gender') || checkLeadField('gender')">
            <el-col :span="24">
              <label for="">{{$t(`gender`)}} {{checkRequire('gender','*')}}</label>
            </el-col>
            <el-col :span="24">
              <el-radio-group name="gender" style="margin-top:5px" v-validate="checkRequire('gender','required')" v-model="leadInfo.gender">
                <template v-for="(item,key) in data.gender.data">
                  <el-radio :label="item.dataValue" :key="`gender-${key}`">{{item.dataValue}}</el-radio>
                </template>
              </el-radio-group>
            </el-col>
            <el-col :sm="24" class="error-message" v-if="errors.has('gender')">
              {{$t(`pleaseChooseGender`)}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px" v-if="checkRequire('birthday') || checkLeadField('birthday')">
            <el-col :span="24">
              <label for="">{{$t(`birthday`)}} {{checkRequire('birthday','*')}}</label>
            </el-col>
            <el-col :span="24">
              <el-date-picker :class="errors.has('birthday') ? 'is-error':''" name="birthday" style="margin-top:5px;width:100%" v-model="leadInfo.birthday" v-validate="checkRequire('birthday','required')" type="date" placeholder="Chọn ngày">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px" v-if="checkRequire('address') || checkLeadField('address')">
            <el-col :span="24">
              <label for="">{{$t(`address`)}} {{checkRequire('address','*')}}</label>
            </el-col>
            <el-col :span="24">
              <el-input :class="errors.has('address') ? 'is-error':''" name="address" style="margin-top:5px" v-validate="checkRequire('address','required')" type="text" placeholder="Địa chỉ" v-model="leadInfo.address">
                <i slot="prefix" class="el-input__icon el-icon-location-outline"></i>
              </el-input>
            </el-col>
          </el-row>
        </div>
        <div style="margin-top:50px;margin-bottom:10px;" v-if="!$route.params.leadId">
          <label style="font-size: 16px;font-weight: bold;">{{$t(`surveyInfo`)}}</label>
        </div>
        <single-survey v-for="(item) in surveyLead" :key="item.id" :item="item"></single-survey>
        <div style="text-align:right">
          <el-button size="medium" type="primary" @click="submitInfo" :loading="loading">{{$t(`sent`)}}</el-button>
        </div>
      </el-card>
    </el-col>
  </el-row>

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { filter, map, orderBy, isEmpty, each, debounce } from 'lodash'
import Survey from '../components/SingleSurvey'
import { i18n } from '../i18n-setup.js';
export default {
  components: {
    'single-survey': Survey
  },
  provide() {
    return {
      parentValidator: this.$validator
    }
  },
  data() {
    return {
      data: {},
      surveyLead: [],
      leadInfo:{
        fullName: '',
        phone: '',
        email: '',
        gender: '',
        birthday: '',
        address: '',
      },
      loading: false,
      countQuestion: 0,
      countSurveyItem: 0,
      countGenerateLead: 0
    }
  },
  computed: {
    ...mapState({
      surveys: state => state.surveys
    })
  },
  watch:{
    surveys: {
      handler: function (val, oldVal) {
        if(val && val.length){
          this.countSurveyItem = 0;
          _.forEach(val,(o) =>{
            if(o.values[0]){
              this.countSurveyItem++;
            }
          });
        }
      },
      deep: true
    },
    leadInfo:{
      handler: function (val, oldVal) {
        var _this =this;
        if(val && !this.$route.params.leadId && _this.data.surveyName.leadFields){
          _this.countGenerateLead = 0;
          _.forEach(_this.data.surveyName.leadFields,(o)=>{
            if(_this.leadInfo[o]){
              _this.countGenerateLead++;
            }
          });
        }
      },
      deep: true
    }
  },
  async created() {
    let _this = this
    //`https://api.gtmjs.com/api/o2o/survey?surveyId=5b6d26baf53708000d170387&leadId=5da3d6ae8cad46000facf2ed`
    let request = await _this.axios.post(
      `https://api.gtmjs.com/api/o2o/survey?surveyId=${_this.$route.params.surveyId || ''}&leadId=${_this.$route.params
        .leadId || ''}`
    )
    if (request.data.success && request.data.data) {
      _this.data = request.data.data
      _this.surveyLead = _this.recursiveData(
        map(_this.data.surveyDetail, v => {
          v.type = `survey-${v.type}`
          return v
        })
      )
      if(_this.data.surveyName.leadFields && !_this.$route.params.leadId){
        _this.countQuestion = _this.data.surveyName.leadFields.length;
      }
      if(_this.data.surveyDetail){
        var questionSurveyDetail = _.filter(_.cloneDeep(_this.data.surveyDetail),(o)=>{return o && (o.type != 'survey-html' && o.type != 'survey-label')});
        _this.countQuestion = _this.countQuestion + questionSurveyDetail.length;
      }
      if(_this.data.surveyName.language){
        i18n.locale = _this.data.surveyName.language;
      }
    }
  },
  methods: {
    ratePercentQuestionAns(numberQuestionReply,totalNumberQuestion){
      var _this = this;
      if(totalNumberQuestion > 0){
        return  ((numberQuestionReply/totalNumberQuestion)*100).toFixed(2);
      }
      return 0
    },
    checkLeadField(field) {
      return this.data.surveyName.leadFields && this.data.surveyName.leadFields.indexOf(field) > -1
    },
    checkRequire(field, customtext) {
      var check = this.data.leadRequire.indexOf(field) > -1
      if (check && customtext) {
        return customtext
      } else {
        return ''
      }
      return check
    },
    recursiveData(array, parent, tree) {
      let _this = this
      tree = typeof tree !== 'undefined' ? tree : []
      parent = typeof parent !== 'undefined' ? parent : { id: '' }
      var children = map(array, function(o) {
        if (!o.parentId || o.parentId == '0') o.parentId = ''
        o.label = o.header.text
        return o
      })
      children = filter(children, function(child) {
        return child.parentId == parent.id
      })
      children = orderBy(children, ['ordinal', 'createdAt'], ['asc'])
      if (!isEmpty(children)) {
        if (parent.id == '') {
          tree = children
        } else {
          parent['children'] = children
        }
        each(children, function(child) {
          _this.recursiveData(array, child)
        })
      }

      return tree
    },
    submitInfo: debounce(async function() {
      let _this = this
      await _this.$validator.validateAll().then(async result => {
        if (result) {
          _this.loading = true

          var data = {
            surveyItems: _this.surveys,
            companyId: _this.data.surveyName.companyId,
            surveyHeaderId: _this.$route.params.surveyId || '',
            leadId: _this.$route.params.leadId || '',
            leadInfo: _this.leadInfo
          }
          try {
            await _this.axios.post('https://api.gtmjs.com/api/o2o/survey/submit', data)
            _this.$router.push('/thanks')
            _this.loading = false
          } catch (error) {
            _this.loading = false
          }
        } else {
          _this.$notify({
            title: '',
            message: 'Vui lòng nhập các thông tin bắt buộc',
            type: 'warning'
          })
        }
      })
    }, 500)
  }
}
</script>
